import { call, takeEvery } from 'redux-saga/effects'

import { sendUnauthenticatedGetRequestToAPI } from 'modules/generators/requestsToAPI'

export const GET_MURFY_PAGES_REQUEST = 'MurfyPage/GET_MURFY_PAGES_REQUEST'
export const GET_MURFY_PAGES_SUCCESS = 'MurfyPage/GET_MURFY_PAGES_SUCCESS'
export const GET_MURFY_PAGES_ERROR = 'MurfyPage/GET_MURFY_PAGES_ERROR'

export function getMurfyPagesRequest (companyId) {
  return {
    type: GET_MURFY_PAGES_REQUEST,
    payload: companyId
  }
}

export function getMurfyPagesSuccess (pages) {
  return {
    type: GET_MURFY_PAGES_SUCCESS,
    payload: pages
  }
}

export function getMurfyPagesError (error) {
  return {
    type: GET_MURFY_PAGES_ERROR,
    payload: error
  }
}

export const getMurfyPagesSelector = (state, murfyPageType) => {
  const pages = state.murfyPages.pages
  return (
    pages ? pages.find(page => page.page_type === murfyPageType) : {}
  )
}

export function * getMurfyPages (action) {
  const companyId = action.payload
  const route = `/murfy-app/murfy-page/?companyId=${companyId}`

  yield call(
    sendUnauthenticatedGetRequestToAPI,
    route,
    getMurfyPagesSuccess,
    getMurfyPagesError
  )
}

export function * getMurfyPagesSaga () {
  yield takeEvery(GET_MURFY_PAGES_REQUEST, getMurfyPages)
}

const initialState = {
  pages: [],
  error: null
}

export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_MURFY_PAGES_REQUEST:
      return {
        ...state,
        error: null
      }
    case GET_MURFY_PAGES_SUCCESS:
      return {
        ...state,
        pages: action.payload
      }
    case GET_MURFY_PAGES_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer
